module.exports = "<router-outlet></router-outlet>\r\n\r\n\r\n"